import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-baaf8456")

_pushScopeId("data-v-baaf8456")
const _hoisted_1 = { class: "w-full flex flex-col gap-y-4 city-exclude-radio" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  for: "discount1",
  class: "cursor-pointer"
}, "Default", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "discount2",
  class: "cursor-pointer"
}, "Custom", -1)
const _hoisted_4 = { class: "flex flex-row py-4" }
const _hoisted_5 = { class: "w-full px-6 space-x-8 flex flex-row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_custom_drowpdown = _resolveComponent("custom-drowpdown")!

  return (_openBlock(), _createBlock(_component_custom_drowpdown, {
    placeholder: _ctx.placeholder,
    value: _ctx.radioValue,
    isDisabled: false,
    isExpand: _ctx.dropdownDiscountOpened,
    "onUpdate:isExpand": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dropdownDiscountOpened = $event))
  }, {
    default: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.watchModelValue) + " ", 1),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", {
          class: "p-field-radiobutton gap-x-3 flex flex-row",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, [
          _createVNode(_component_RadioButton, {
            id: "discount1",
            name: "city-exclude",
            value: "Default",
            modelValue: _ctx.radioValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.radioValue = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_2
        ]),
        _createVNode("div", {
          class: "p-field-radiobutton gap-x-3 flex flex-row",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, [
          _createVNode(_component_RadioButton, {
            id: "discount2",
            name: "city-exclude",
            value: "Custom",
            modelValue: _ctx.radioValue,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.radioValue = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_3
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('posFavourite.editMemberModal.discount'),
              class: "w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  "data-testid": "pos-favorite-edit-member-input-discount",
                  modelValue: _ctx.discountValue,
                  onChange: _ctx.onChangeValueDiscount,
                  format: _ctx.formatDefaultDiscount,
                  suffix: "%",
                  error: _ctx.parsedDefaultDisount > 25,
                  errorCaption: _ctx.$t('posFavourite.editMemberModal.maxDiscount'),
                  errorIcon: false,
                  disabled: _ctx.modelValue[0].name === 'Default'
                }, null, 8, ["modelValue", "onChange", "format", "error", "errorCaption", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["placeholder", "value", "isExpand"]))
})